import Vue from 'vue'
import VueRouter from 'vue-router'
import Datav from './components/datav/index.vue'
import Login from './components/Login.vue'
// import Flow from "./components/dialog/EnterpriseFlowChart";

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Datav,
      // component: Flow,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/login',
      component: Login,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/dev1',
      component: () => import('@/components/datav/EnterpriseMap'),
      meta: {
        requireAuth: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    if (localStorage.getItem('Authorization')) {
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next()
  }
})

router.onError(err => {
  console.log(err.message)
})

export default router
